module.exports = __webpack_public_path__ + "static/media/17.650a6c93.jpg";